import React from 'react';
import moment from 'moment';
import { toast } from 'react-toastify';

/**
 * "Last updated by X on ..." strip for the global form-config pages, plus the
 * two small bits of save handling every Configure page repeats.
 */
export const ConfigMeta = ({ meta }) => {
    if (!meta?.modifiedOn) return null;
    return (
        <p className="text-muted mb-0" style={{ fontSize: '0.85rem' }}>
            Last updated{meta.modifiedByName ? ` by ${meta.modifiedByName}` : ''} on{' '}
            {moment(meta.modifiedOn).format('DD-MM-YYYY HH:mm')}
        </p>
    );
};

/**
 * First active section with no item that has a non-empty label, or null if all are valid.
 * A section with no labelled items has nothing to save the API can point to, so it
 * silently disappears on the next load - catch it before submit instead. Sections marked
 * inactive (deleted) are exempt - they're being removed, not saved.
 */
export const findEmptySection = (sections) =>
    sections.find((section) => section.active !== false && !section.items.some((item) => item.label && item.label.trim() !== '')) || null;

/** True when the save failed because someone else saved first. */
export const isStaleConfigError = (error) =>
    error?.code === 'STALE_CONFIG' || /changed since you loaded it/i.test(error?.message || error || '');

/**
 * Toasts the outcome of a config save. Items still referenced by a submission
 * cannot be hard-deleted, so the API deactivates them instead and reports them
 * back as skippedIds - say so rather than silently doing something else.
 */
export const toastSaveResult = (result) => {
    const skipped = result?.skippedIds?.length || 0;
    toast.success(result?.message || 'Configuration saved.');
    if (skipped > 0) {
        toast.info(`${skipped} item(s) are used by existing submissions - deactivated instead of deleted.`);
    }
};

/** Trash control that hard-deletes a saved config item (or drops an unsaved row). */
export const DeleteItemButton = ({ onClick, title = 'Delete permanently' }) => (
    <button
        type="button"
        className="btn btn-sm btn-outline-danger ms-2"
        title={title}
        onClick={onClick}
    >
        <i className="bx bx-trash" />
    </button>
);
